import React, { useContext, useEffect, useState } from 'react';
import '../../assets/css/donordashboard/Notification.css';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import AppContext from '../../context/AppContext';
import MasterLayout from "../../components/layout/MasterLayout";
import axios from 'axios';

const Notification = () => {
  const { baseUrl, loggedInDonorId } = useContext(AppContext); //  loggedInDonorId add kiya
  console.log("Logged In Donor ID:", loggedInDonorId);
  const [filterType, setFilterType] = useState('all');
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCategoryDetails = (category) => {
    switch (category) {
      case 'donation': return { icon: '📦', variant: 'teal' };
      case 'badge':    return { icon: '🏅', variant: 'warning' };
      case 'urgent':   return { icon: '🚨', variant: 'danger' };
      case 'system':   return { icon: '⚙️', variant: 'info' };
      default:         return { icon: '🔔', variant: 'secondary' };
    }
  };

  // ✅ donor_id params ke saath fetch
  const fetchNotifications = () => {
    setLoading(true);
    axios.get(`${baseUrl}/donor/notifications`, {
      params: { donor_id: loggedInDonorId }
    })
      .then(response => {
        setNotifications(response.data.notifications || []);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching notifications:", error);
        setLoading(false);
      });
  };

  // ✅ donor_id body ke saath mark single read
  const handleMarkAsRead = (id) => {
    axios.post(`${baseUrl}/donor/notifications/${id}/read`, {
      donor_id: loggedInDonorId
    })
      .then(() => {
        setNotifications(notifications.map(n =>
          n.id === id ? { ...n, read: true } : n
        ));
      })
      .catch(error => console.error("Error marking notification as read:", error));
  };

  // ✅ donor_id body ke saath mark all read
  const handleMarkAllAsRead = () => {
    axios.post(`${baseUrl}/donor/notifications/mark-all-read`, {
      donor_id: loggedInDonorId
    })
      .then(() => {
        setNotifications(notifications.map(n => ({ ...n, read: true })));
      })
      .catch(error => console.error("Error marking all as read:", error));
  };

  // ✅ donor_id data ke saath delete
  const handleDeleteNotification = (id) => {
    if (window.confirm('Are you sure you want to delete this notification?')) {
      axios.delete(`${baseUrl}/donor/notifications/${id}`, {
        data: { donor_id: loggedInDonorId }
      })
        .then(() => {
          setNotifications(notifications.filter(n => n.id !== id));
        })
        .catch(error => console.error("Error deleting notification:", error));
    }
  };

  useEffect(() => {
    if (loggedInDonorId) fetchNotifications(); // ✅ sirf tab fetch karo jab id ho
  }, [loggedInDonorId]);

  const filteredNotifications = notifications.filter(n => {
    if (filterType === 'all') return true;
    if (filterType === 'unread') return !n.read;
    return n.category === filterType;
  });

  return (
    <MasterLayout>
      <div className="sdms-notifications-page">
        {/* Page Header */}
        <div className="page-header-section mb-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <h2 className="page-title">
                <span className="title-icon">🔔</span> Notification Center
              </h2>
              <p className="text-muted sub-title">Track your SDMS donations, earned badges, and urgent camp alerts</p>
            </div>
            <button
              className="btn-mark-all"
              onClick={handleMarkAllAsRead}
              disabled={!notifications.some(n => !n.read)}
            >
              Mark All Read
            </button>
          </div>
        </div>

        {/* Stats Section */}
        <Row className="mb-4">
          <Col xl={3} sm={6} className="mb-3">
            <Card className="sdms-stat-card total-card">
              <Card.Body className="d-flex align-items-center gap-3">
                <div className="stat-icon-wrapper">📬</div>
                <div>
                  <h3>{notifications.length}</h3>
                  <p>Total Updates</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} sm={6} className="mb-3">
            <Card className="sdms-stat-card unread-card">
              <Card.Body className="d-flex align-items-center gap-3">
                <div className="stat-icon-wrapper">💬</div>
                <div>
                  <h3>{notifications.filter(n => !n.read).length}</h3>
                  <p>Unread Alerts</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} sm={6} className="mb-3">
            <Card className="sdms-stat-card reward-card">
              <Card.Body className="d-flex align-items-center gap-3">
                <div className="stat-icon-wrapper">🏅</div>
                <div>
                  <h3>{notifications.filter(n => n.category === 'badge').length}</h3>
                  <p>Badges & Levels</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xl={3} sm={6} className="mb-3">
            <Card className="sdms-stat-card urgent-card">
              <Card.Body className="d-flex align-items-center gap-3">
                <div className="stat-icon-wrapper">🚨</div>
                <div>
                  <h3>{notifications.filter(n => n.category === 'urgent' && !n.read).length}</h3>
                  <p>Urgent Requests</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filter Controls */}
        <div className="filter-button-group mb-4">
          {['all', 'unread', 'donation', 'badge', 'urgent'].map((type) => (
            <button
              key={type}
              className={`filter-btn ${filterType === type ? 'active' : ''}`}
              onClick={() => setFilterType(type)}
            >
              {type.charAt(0).toUpperCase() + type.slice(1)}
              {type === 'unread' && ` (${notifications.filter(n => !n.read).length})`}
            </button>
          ))}
        </div>

        {/* Main Content Area */}
        <Card className="notifications-container-card">
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center py-5 text-muted">Loading notifications...</div>
            ) : filteredNotifications.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <p className="fs-5 mb-1">All caught up! 🎉</p>
                <p className="small">No notifications found in this category.</p>
              </div>
            ) : (
              <ListGroup variant="flush">
                {filteredNotifications.map((notification) => {
                  const details = getCategoryDetails(notification.category);
                  return (
                    <ListGroup.Item
                      key={notification.id}
                      className={`notification-item-row ${!notification.read ? 'unread-highlight' : ''}`}
                      onClick={() => !notification.read && handleMarkAsRead(notification.id)}
                    >
                      <div className="d-flex align-items-start gap-3 w-100">
                        <div className={`category-badge-icon bg-light-${details.variant}`}>
                          {details.icon}
                        </div>
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between align-items-start flex-wrap">
                            <div>
                              <h6 className="item-title mb-1">
                                {notification.title}
                                {!notification.read && <span className="ms-2 new-badge">New</span>}
                              </h6>
                              <p className="item-message mb-2">{notification.message}</p>
                              {/* ✅ food_id show karo agar ho */}
                              {notification.food_id && (
                                <small className="text-muted d-block mb-1">
                                  🍱 Food ID: <strong>#{notification.food_id}</strong>
                                </small>
                              )}
                              <small className="item-time">
                                📅 {new Date(notification.created_at || Date.now()).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })}
                              </small>
                            </div>
                            <button
                              className="btn-delete-action text-danger p-1 ms-auto"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteNotification(notification.id);
                              }}
                            >
                              🗑️
                            </button>
                          </div>
                        </div>
                      </div>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            )}
          </Card.Body>
        </Card>
      </div>
    </MasterLayout>
  );
};

export default Notification;